<template>
  <load mode="table" message="Carregando termo de compromisso" v-if="loading" />
  <div v-else class="card mb-0 shadow">
    <div class="card-body">
      <div class="tab-content">
        <div class="animate__animated animate__fadeIn">
          <div class="row">
            <div class="col-12">
              <h4 class="font-weight-bold">Termo de Compromisso</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <editor
                apiKey="xmvncqtu4n5y7d1xpaa2l21cl207m7ggc6zljyk7emudl10c"
                v-model="text_edit"
                ref="termoTextarea"
                :init="init"
              />
            </div>
          </div>
          <div style="display: none" class="row">
            <div class="col-12" id="boxPrint">
              <print-header />
              <div v-html="text_edit"></div>
            </div>
          </div>
          <div class="row px-2 d-flex justify-content-end">
            <button
              class="btn btn-primary"
              :title="$t('Visualizar e Imprimir')"
              @click="print"
            >
              <i class="mdi mdi-printer mdi-18px" />
            </button>
            <b-button class="btn btn-default" @click="redefinir">
              <i class="mdi mdi-autorenew mdi-18px" />
            </b-button>
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
              @click="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
export default {
  props: ["medida"],
  components: {
    editor: Editor,
  },
  data() {
    return {
      observacoes: "",
      loading: true,
      app_cidade: this.$store.state.settings.app_cidade,
      text_edit: "",
      text_default:
        '<h2 style="text-align: center;">Termo de Compromisso</h2><p style="text-align: justify;">Eu, <span id="socioeducando">______________________________________</span> (socioeducando), declaro ter sido devidamente orientado (a) sobre condicionalidades para o cumprimento das Medidas Socioeducativas em Meio Aberto e tenho o interesse cumpri-las, as quais s&atilde;o:</p><p>I. comparecer aos atendimentos;&nbsp;<br />II. participar dos grupos destinados ao adolescente;&nbsp;<br />III. participar do grupo de respons&aacute;veis;&nbsp;<br />IV. estar inserido na rede regular de ensino;&nbsp;<br />V. prover um bom comportamento familiar e comunit&aacute;rio;&nbsp;<br />VI. Em caso de PSC, prestar servi&ccedil;o comunit&aacute;rio na institui&ccedil;&atilde;o ____________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p><p style="text-align: justify;">Eu, <span id="responsavel">____________________________________________</span>, enquanto respons&aacute;vel pelo socioeducando supracitado, comprometo-me a colaborar com o adolescente no cumprimento das metas estabelecidas neste plano individual de atendimento (PIA).</p><p>&nbsp;</p><p style="float: right;"><span id="cidade">São Paulo</span>,<span id="data">_____ de ________________ de 2021</span><br /><br /></p><p>&nbsp;</p><p>&nbsp;</p><p><strong>Observa&ccedil;&otilde;es Gerais:</strong></p><p>___________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________________</p><p><strong>ASSINATURAS DE COMPROMISSO:</strong></p><p>&nbsp;</p><p style="text-align: center;">___________________________________________________________________</p><p style="text-align: center;"><strong>SOCIOEDUCANDO</strong></p><p>&nbsp;</p><p style="text-align: center;">___________________________________________________________________</p><p style="text-align: center;"><strong>RESPONS&Aacute;VEL</strong></p><p>&nbsp;</p><p style="text-align: center;">___________________________________________________________________</p><p style="text-align: center;"><strong>T&Eacute;CNICO DE REFER&Ecirc;NCIA DO CREAS</strong></p><p>&nbsp;</p><p style="text-align: center;">___________________________________________________________________</p><p style="text-align: center;"><strong>ORIENTADOR PSC</strong></p>',
      init: {
        height: 500,
        menubar: false,
        plugins: ["lists link image", "code fullscreen", "paste code"],
        toolbar:
          "undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help",
      },
    };
  },
  mounted() {
    this.text_edit = this.changeText(this.text_default);
    this.getTermo();
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      if (ladda) {
        ladda.start();
      }
      axios
        .post(`api/dashboard/store/termo`, {
          medida_id: this.medida.id,
          texto: this.text_edit,
        })
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Termo cadastrado com sucesso.",
          });
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    getTermo() {
      this.loading = true;
      axios
        .get(`api/dashboard/get/termo/${this.medida.id}`)
        .then((response) => {
          if (response.data.texto) {
            this.$refs.termoTextarea.value = response.data.texto;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redefinir() {
      this.$refs.termoTextarea.value = this.changeText(this.text_default);
    },
    changeText(string) {
      if (string) {
        string = string.replace(
          `<span id="socioeducando">______________________________________</span>`,
          `<b>${this.medida.usuario_nome}</b>`
        );
        string = string.replace(
          `<span id="responsavel">____________________________________________</span>`,
          `<b>${this.medida.familia_id.responsavel_familiar.nome_completo}</b>`
        );
        string = string.replace(
          `<span id="cidade">São Paulo</span>`,
          this.app_cidade
        );
        string = string.replace(
          `<span id="data">_____ de ________________ de 2021</span>`,
          moment().format("LL")
        );
      }

      return string;
    },

    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>
<style lang="css">
.tox-statusbar {
  display: none !important;
}
</style>
